export const HandlerTypes = {
  sms: "sms",
  email: "email",
  webhook: "webhook",
  sensio: "sensio",
  netnordic: "netnordic",
  skyresponse: "skyresponse",
} as const;

export type HandlerType = (typeof HandlerTypes)[keyof typeof HandlerTypes];
